import templateUrl from './views/component.tpl.html';
import AlGuestlistProtectedFilesController from './controllers/component';

angular.module('festzelt-os.modules.guestlists')
    .component('alGuestlistProtectedFiles', {
        bindings: {
            guestlist: '<'
        },
        controller: AlGuestlistProtectedFilesController,
        controllerAs: 'vm',
        templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-protected-files/component.js